import React from 'react'

export default class QuestionCircleOutline extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
            >
                <path
                    d='M10.0001 18.3337C14.6025 18.3337 18.3334 14.6027 18.3334 10.0003C18.3334 5.39795 14.6025 1.66699 10.0001 1.66699C5.39771 1.66699 1.66675 5.39795 1.66675 10.0003C1.66675 14.6027 5.39771 18.3337 10.0001 18.3337Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7.57495 7.50047C7.77087 6.94353 8.15758 6.4739 8.66658 6.17475C9.17558 5.87561 9.77403 5.76626 10.3559 5.86607C10.9378 5.96588 11.4656 6.26841 11.8458 6.72008C12.2261 7.17175 12.4342 7.74341 12.4333 8.33381C12.4333 10.0005 9.93328 10.8338 9.93328 10.8338'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M10 14.167H10.0083'
                    stroke='#7950EA'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
